type TableColumnAlignment = 'left' | 'center' | 'right'

export type TableColumnProps = {
  width?: string
  label: string
  align?: TableColumnAlignment
}

export class TableColumn {
  label: string
  width?: string
  align: string

  constructor({ width, label, align = 'left' }: TableColumnProps) {
    this.label = label
    this.width = width
    this.align = align
  }
}
